import Vue from "vue";
import App from "./App";
import "./registerServiceWorker";

// State
import store from "./store/store";

// idioma
import VueI18n from "vue-i18n";
import messages from "@/settings/i18n/statesIn";

// rutas
import router from "@/settings/router";

// metricas
import VueAnalytics from "vue-analytics";

// plugins
import "./plugins/sweetalert2.ts";
import "./plugins/currency.ts";
import "./plugins/moment.ts";
// import './plugins/hotjar.ts'

// scss
import "@/scss/settings.scss";

// UI componentes para la interfaz
import * as Sentry from "@sentry/browser";
import * as VueGoogleMaps from "vue2-google-maps";

// import 'moment/locale/es.js';

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCne3UGkUuc2wDDAvpLB9CzpRQ_DGbk13s",
    libraries: "places",
  },
  installComponents: true,
});

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "es", // set locale
  messages, // set locale messages
});

Sentry.init({
  dsn: "https://421a58b086744b6794723e439a6960c4@o227299.ingest.sentry.io/5191310",
  integrations: [new Sentry.Integrations.Vue({ Vue })],
});

const isProd = process.env.NODE_ENV === "production";
Vue.use(VueAnalytics, {
  id: "UA-161532148-1",
  router,
  debug: {
    enable: !isProd,
    sendHitTask: isProd,
  },
  linkers: ["tienda.todoscomemos.com"],
});

Vue.directive("click-outside", {
  bind: function (el: any, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el: any) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
}).$mount("#app");
store.dispatch("loadSegment");
